import { render } from "./DataRequestSelector.vue?vue&type=template&id=98a3de40&scoped=true"
import script from "./DataRequestSelector.vue?vue&type=script&lang=js"
export * from "./DataRequestSelector.vue?vue&type=script&lang=js"

import "./DataRequestSelector.vue?vue&type=style&index=0&id=98a3de40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a3de40"]])

export default __exports__